import React, { useContext } from 'react'
import { ScoreCardContext } from '../../store/scorecard-context'
import { isAllQuestionAnswered } from './common'
import styles from './ScoreCard.module.css'
import { ScoreCardOptions } from '../../types/interface'


const Options = ({options, questionUUID, sectionUUID, sectionIndex, questionIndex}: any) => {

    const scorecardCtx = useContext(ScoreCardContext)

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
        let  scores = JSON.parse(JSON.stringify(scorecardCtx.scores))
        scores.sections[scorecardCtx.activeSection].questions[questionIndex].options.map((option: ScoreCardOptions) => {
            option.is_answer = false
        })
        scores.sections[scorecardCtx.activeSection].questions[questionIndex].options[i].is_answer = e.target.checked


        // To check if all sections reviewed
        // This is done to enable the Submit Review
        // let isAllAnswered = isAllQuestionAnswered(scores)
        // scorecardCtx.updateReviewedScore(isAllAnswered)

        scorecardCtx.updateScores(scores)
        
    }
                             
    const optionsUI = options && options.map(({name, is_answer, score}: any, index: number) => {   
        return  <li key={`answer-${questionIndex}-${index}`} className={`d-flex align-items-center mb-0`}>
                    <input 
                        type="radio" 
                        name={`answer-${questionIndex}`}
                        id={`answer-${questionIndex}-${index}`}
                        className={`${styles.checkboxInput} btn-check`} 
                        checked={is_answer}
                        onChange={(e) => onChangeHandler(e, index)}
                    />
                    <label className={`m-0 me-2 ${styles.questionOption} ${is_answer ? `btn ${styles.selectedOption}` : ''}`} htmlFor={`answer-${questionIndex}-${index}`}>{name}</label>
                </li>
    })

    return (
        <>
            { optionsUI }
        </>
    )
}

export default Options
